import tg_1 from "./images/tg_1.png";
import tg_2 from "./images/tg_2.png";
import tg_3 from "./images/tg_3.png";
import tg_4 from "./images/tg_4.png";

export const tg_data = [
    {
        image: tg_1,
        title: "Good for Producers & Suppliers",
        description: () => (
            <>
                <p>
                    At Desi Fresh, we are committed to sourcing in a fair and sustainable way, where every purchase you make helps improve
                    the lives of people and animals, promotes long-term food production, and fosters stronger relationships within our
                    multicultural communities.
                </p>

                <p>
                    <strong>Supplier Relationships:</strong> We believe in fostering mutually beneficial relationships with our suppliers,
                    ensuring fair treatment, and supporting local economies to create a positive impact on communities. Human Rights &
                    Ethical Trade: Respecting human rights is at the core of our sourcing practices. We collaborate with suppliers who
                    uphold ethical trade standards, ensuring fair wages and safe working conditions for all.
                </p>

                <p>
                    <strong>Fairtrade:</strong> By supporting Fairtrade practices, we empower farmers and producers, providing them with
                    fair compensation for their hard work and dedication, contributing to sustainable livelihoods.
                </p>

                <p>
                    <strong>Transparency:</strong> We value transparency and strive to provide you with clear information about our
                    products' origins, sourcing methods, and ethical standards, enabling you to make informed and responsible choices.
                </p>

                <p>
                    <strong>Animal Welfare:</strong> We prioritize the well-being of animals involved in our supply chain. Our commitment to
                    high animal welfare standards ensures that our products are sourced responsibly and ethically.
                </p>
            </>
        ),
    },
    {
        image: tg_2,
        title: "Good for Consumers",
        description: () => (
            <>
                <p>
                    At Desi Fresh, we are dedicated to promoting sustainable nutrition, making conscious eating easy, affordable, and
                    accessible to all. Our commitment to sustainability extends across our product selection, supply chain, and community
                    engagement. Here's our structured sustainability nutrition statement:
                </p>
                <p>
                    <strong>High-Quality Products for a Conscious Lifestyle:</strong> Eating consciously should not be complicated or
                    costly. At Desi Fresh, we offer a wide array of high-quality products that enable you and your entire family to embrace
                    a conscious lifestyle. Our commitment to providing reasonable prices ensures that sustainable choices are within reach
                    for all customers.
                </p>
                <p>
                    <strong>Fresh and Sustainable Supply Chain:</strong> We take pride in our daily supply of fresh fruits and vegetables,
                    sourced responsibly to reduce our environmental impact. Furthermore, we are continually expanding our extensive organic
                    range and diverse plant-based products, supporting sustainable agricultural practices and reducing our carbon footprint.
                </p>
                <p>
                    <strong>Catering to Diverse Dietary Preferences:</strong> At Desi Fresh, we understand that every individual has unique
                    dietary preferences and nutritional needs. Whether you are looking for vegan options, regional and local products, or
                    organic choices, we are here to assist you in making informed decisions. Additionally, if you prioritize low-salt or
                    low-sugar products or pay attention to nutritional values and calories, we have you covered.
                </p>

                <p>
                    <strong>Accessibility and Community Care:</strong> Ensuring safe, affordable, and nutritious food for all is a core
                    aspect of our sustainability mission. We actively engage in charity partnerships to address food insecurity and
                    contribute to our local communities' well-being.
                </p>
            </>
        ),
    },
    {
        image: tg_3,
        title: "Good for the Planet",
        description: () => (
            <>
                <p>
                    We are committed to being "Good for the Planet" by promoting the sustainable and efficient use of resources while
                    minimizing losses throughout the food system. Our dedication to this cause encompasses several critical areas:
                </p>

                <p>
                    <strong>Climate Change:</strong> We acknowledge the urgent need to address climate change and its impact on the
                    environment. Through our sustainable practices, we strive to reduce greenhouse gas emissions and minimize our carbon
                    footprint. We continuously explore innovative ways to lessen our impact on the climate and contribute to a healthier
                    planet
                </p>
                <p>
                    <strong>Food Waste:</strong> Food waste is a significant issue that affects both the environment and food security. At
                    Desi Fresh, we are dedicated to minimizing food waste at every stage of the supply chain. By implementing efficient
                    inventory management, responsible sourcing, and customer awareness campaigns, we strive to reduce food waste and its
                    negative consequences.
                </p>
                <p>
                    <strong>Plastic:</strong> Plastic pollution poses a severe threat to marine life and ecosystems. As part of our
                    sustainability commitment, we are actively working to reduce the use of single-use plastic in our operations and
                    packaging. We promote eco-friendly alternatives and encourage customers to join us in the fight against plastic
                    pollution.
                </p>
                <p>
                    <strong>Deforestation:</strong> Protecting forests is crucial for biodiversity conservation and combating climate
                    change. We are committed to sourcing products responsibly to avoid contributing to deforestation. By supporting
                    suppliers who practice sustainable forestry and land management, we aim to preserve vital ecosystems.
                </p>
                <p>
                    <strong>Saving Water:</strong> Water is a precious resource, and its efficient use is essential in mitigating
                    environmental impacts. Through water-saving initiatives in our operations and partnerships with suppliers who prioritize
                    responsible water management, we work towards preserving this invaluable resource.
                </p>
            </>
        ),
    },
    {
        image: tg_4,
        title: "Good for the Social Causes",
        description: () => (
            <>
                <p>
                    At Desi Hands (Desi Fresh initiative), we are dedicated to creating a positive impact on the lives of underprivileged
                    kids through sustainable social causes. We firmly believe that every child deserves equal opportunities to thrive and
                    succeed. Our commitment to this cause spans several key areas:
                </p>
                <p>
                    <strong>Education Empowerment:</strong> Education is a powerful tool that can break the cycle of poverty. We actively
                    support educational initiatives that provide underprivileged kids with access to quality education, resources, and
                    learning opportunities. By empowering them with knowledge and skills, we aim to build a brighter future for these
                    children.
                </p>
                <p>
                    <strong>Nutritious Meals and Health Care:</strong> Ensuring that underprivileged kids have access to nutritious meals
                    and proper healthcare is crucial for their growth and development. We work to support programs that provide essential
                    nutritional support and access to healthcare services, improving the overall well-being of these children.
                </p>
                <p>
                    <strong>Mentoring and Guidance:</strong> Positive role models and mentors can significantly impact a child's life. We
                    encourage mentorship programs that provide underprivileged kids with guidance, support, and inspiration to achieve their
                    full potential.
                </p>
                <p>
                    <strong>Advocacy and Awareness:</strong> Raising awareness about the challenges faced by underprivileged kids is
                    essential in driving positive change. We advocate for their rights and needs, striving to build a more inclusive and
                    compassionate society.
                </p>
            </>
        ),
    },
];
